import { render } from "./ModalSteps.vue?vue&type=template&id=227a9fa9"
import script from "./ModalSteps.vue?vue&type=script&lang=js"
export * from "./ModalSteps.vue?vue&type=script&lang=js"

import "./ModalSteps.vue?vue&type=style&index=0&id=227a9fa9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__